import { MDS_REQUEST_OUT_CODE, MDS_REQUEST_OUT_TIME } from "@/constants/w-socket";

export function getRequestTimeout(handleMessage = () => {}) {
	let timeoutRef = setTimeout(() => {
		timeoutRef = null;
		handleMessage({ rtnCode: MDS_REQUEST_OUT_CODE });
	}, MDS_REQUEST_OUT_TIME);
	return () => timeoutRef && clearTimeout(timeoutRef);
}

const WEB_SOCKET_STATE = {
	READY: "READY",
	OPEN: "OPEN",
	RECONNECT: "RECONNECT",
	CONNECTING: "CONNECTING",
	CLOSED: "CLOSED",
	MANUAL_CLOSED: "MANUAL_CLOSED",
};

export class WebSocketWrapper {
	constructor(url, onMessage, onOpen, onClose, onReconnect) {
		// 连接地址
		this.url = url;
		// 响应方法
		this.onMessage = onMessage;
		// 监听开启方法
		this.onOpen = onOpen;
		// 监听关闭方法
		this.onClose = onClose;
		// 监听重连方法
		this.onReconnect = onReconnect;
		// websocket 实例
		this.webSocket = null;
		// 当前状态
		this.webSocketState = WEB_SOCKET_STATE.READY;
		// 延迟实例
		this.reconnectTimer = null;
		// 开始连接
		this.handleConnect();
		return this;
	}

	handleConnect() {
		if (this.url) {
			this.webSocketState = WEB_SOCKET_STATE.CONNECTING;
			this.webSocket = new WebSocket(this.url);
			this.webSocket.onopen = this.handleOpen.bind(this);
			this.webSocket.onmessage = this.handleMessage.bind(this);
			this.webSocket.onclose = this.handleClose.bind(this);
			this.webSocket.onerror = this.handleError.bind(this);
		}
	}

	handleOpen(event) {
		this.webSocketState = WEB_SOCKET_STATE.OPEN;
		this.onOpen(this, event);
		this.reconnectTimer && clearTimeout(this.reconnectTimer);
		this.reconnectTimer = null;
	}

	handleMessage(response) {
		if (typeof this.onMessage === "function") {
			this.onMessage(this, response.data);
		}
	}

	handleClose(event) {
		if (this.webSocketState === WEB_SOCKET_STATE.MANUAL_CLOSED) return;
		this.webSocketState = WEB_SOCKET_STATE.CLOSED;
		this.onClose(this, event);
		this.reconnect();
	}

	handleError(event) {
		if (this.webSocketState === WEB_SOCKET_STATE.MANUAL_CLOSED) return;
		this.webSocketState = WEB_SOCKET_STATE.CLOSED;
		this.onClose(this, event);
		this.reconnect();
	}

	reconnect() {
		this.reconnectTimer && clearTimeout(this.reconnectTimer);
		this.webSocketState = WEB_SOCKET_STATE.RECONNECT;
		this.reconnectTimer = setTimeout(() => this.handleConnect(), 1000);
		this.onReconnect(this);
	}

	close() {
		if (this.webSocket && this.webSocket.readyState < 2) {
			this.webSocketState = WEB_SOCKET_STATE.MANUAL_CLOSED;
			this.webSocket.close(1000, "iTrade web request close");
		}
		this.reconnectTimer && clearTimeout(this.reconnectTimer);
	}

	send(data) {
		if (this.webSocket) {
			this.webSocket.send(data);
		}
	}
}
